<template>
  <div class="content">
    <header_index></header_index>
    <!-- <div class="top"
         style="background: url('/image/index/jigoubg.png');">
      <div class="topbox EC_width">
        <div class="topEnter"
             @click="toEnter">
          <img src="../../assets/img/icon/fangzi.png"
               alt="">
          <span>入驻机构</span>
          <div></div>
        </div>
      </div>
    </div> -->
    <div class="bannerWrap">
      <swiper :options="swiperOption1"
              ref="mySwiper">
        <swiper-slide v-for="(item, index) in bannerlist"
                      :key="index">
          <div class="bannerBgWrap text_center">
            <img :src="item.resUrl"
                 class="marginRight10 imgvertical-3">
          </div>
        </swiper-slide>
      </swiper>
      <div class="topEnter"
           @click="toEnter">
        <img src="../../assets/img/icon/fangzi.png"
             alt="">
        <span>机构入驻申请</span>
        <div></div>
      </div>
    </div>
    <div class="top2 EC_width"
         v-if="jigouList.length>4">
      <cardSwiper @change="swiperChange"></cardSwiper>
    </div>
    <div class="boxTitle EC_width"
         v-show="kechengList.length>0">
      <span>机构课程</span>
    </div>
    <div class="top3 EC_width"
         v-show="kechengList.length>0">
      <div class="t3top">
        <div class="t3tleft"
             :style="isbqzhankai?'':'height: 35px;'">
          <div class="biaoqian"
               v-for="(item,index) in xiangmuList"
               :key="index"
               :style="xiangmuIndex==item.pId?'color: #fff;background: #007380;':''"
               @click="xiangmuIndex=item.pId">
            <span>{{item.p_Name}}</span>
          </div>
        </div>
        <div class="t3tright"
             @click="isbqzhankai=!isbqzhankai">
          <span v-show="!isbqzhankai">更多</span>
          <span v-show="isbqzhankai">收起</span>
          <img src="../../assets/img/icon/xia3.png"
               :style="isbqzhankai?'margin-left:10px;transform: rotate(180deg);':'margin-left:10px'"
               alt="">
        </div>
      </div>
      <div class="t3mid"
           :style="isbqzhankai?'margin-top: 12px;':''"
           v-show="kechengList.length>0">
        <div class="t3mbox"
             v-for="(item,index) in kechengList"
             :style="(index+1)%4==0?'margin-right:0':''"
             @click="tokecheng(item.id)"
             :key="index">
          <!-- <img :src="item.acr_Pict"
               alt=""> -->
          <el-image :src="item.acr_Pict"
                    class="img"
                    lazy></el-image>
          <div class="t3mboxbot">
            <span class="t3title">{{item.title}}</span>
            <div class="t3biaoqian">
              <div v-for="(items,index) in item.labelName.split(',')"
                   :key="index+'s'"
                   :style="index==0?'margin-left:0':''"
                   v-show="items!=''">
                <span>{{items}}</span>
              </div>
            </div>
            <div class="t3more">
              <span style="color:red"
                    v-show="item.discountStatus == 2">免费</span>
              <span style="color:red"
                    v-show="item.discountStatus == 1">VIP专享</span>
              <span v-show="item.discountStatus == 0">￥{{item.price}}</span>
              <div>
                <img src="../../assets/img/icon/ren.png"
                     style="width:10px;height:11px;margin-right:10px"
                     alt="">
                <span>{{item.playSum}}人</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="t3mid2"
           v-show="kechengList.length==0">
        <span>没有找到符合条件的课程</span>
      </div>
    </div>
    <div class="boxTitle EC_width display_between"
         style="margin-top:40px">
      <span>发现入驻机构</span>
      <div class="t4tsearch display_between">
        <input type="text"
               placeholder="请输入机构名称"
               v-model="orgname">
        <img src="../../assets/img/organ/search.png"
             alt=""
             @click="searchclk()">
      </div>
    </div>
    <div class="top4 EC_width">
      <div class="t4left"
           ref="box1"></div>
      <div class="t4right">
        <div class="t4r1t t4rt"
             :style="province=='请选择省份'?'':'background: #007380;'"
             @click="isprovince=!isprovince;istype=false">
          <span :style="province=='请选择省份'?'':'color:#fff;'">{{province}}</span>
          <img src="../../assets/img/organ/xia1.png"
               v-show="province!='请选择省份'&&!isprovince"
               alt="">
          <img src="../../assets/img/organ/xia2.png"
               v-show="province=='请选择省份'&&!isprovince"
               alt="">
          <img src="../../assets/img/organ/shang1.png"
               v-show="province!='请选择省份'&&isprovince"
               alt="">
          <img src="../../assets/img/organ/shang2.png"
               v-show="province=='请选择省份'&&isprovince"
               alt="">
          <div class="t4r1m t4rm"
               @click.stop
               v-show="isprovince">

            <p v-for="(item,index) in provincelist"
               @click="toprovince(item)"
               :key="index">{{item.label}}</p>
          </div>
        </div>
        <div class="t4r2t t4rt"
             :style="type=='请选择类别'?'':'background: #007380;'"
             @click="istype=!istype;isprovince=false">
          <span :style="type=='请选择类别'?'':'color:#fff;'">{{type}}</span>
          <img src="../../assets/img/organ/xia1.png"
               v-show="type!='请选择类别'&&!istype"
               alt="">
          <img src="../../assets/img/organ/xia2.png"
               v-show="type=='请选择类别'&&!istype"
               alt="">
          <img src="../../assets/img/organ/shang1.png"
               v-show="type!='请选择类别'&&istype"
               alt="">
          <img src="../../assets/img/organ/shang2.png"
               v-show="type=='请选择类别'&&istype"
               alt="">
          <div class="t4r1m t4rm"
               @click.stop
               v-show="istype">

            <p v-for="(item,index) in typelist"
               @click="totype(item)"
               :key="index">{{item.valueText}}</p>
          </div>
        </div>
        <div class="t4r3"
             v-show="organList.length>0">
          <p v-for="(item,index) in organList"
             @click="toorgan(item.id)"
             :key="index">{{item.org_name}}</p>
        </div>
        <div class="t4r3"
             v-show="organList.length==0"
             style="height:75px;line-height:50px;">
          <span>没有找到符合条件的机构！</span>
        </div>
      </div>
    </div>
    <div class="top6f"
         v-if="uid!=0&&myjigoulist.length>0">
      <div class="top6t boxTitle EC_width"
           v-if="uid!=0&&myjigoulist.length>0">
        <span>我的机构课程</span>
        <div class="t6titler">
          <div class="t4r2t t4rt"
               :style="myjigouname=='请选择机构'?'margin-top:0;padding-left:20px;height:38px':'background: #0B8586;margin-top:0;padding-left:20px;height:38px'"
               @click="ismyjigou=!ismyjigou;">
            <span :style="myjigouname=='请选择机构'?'padding-left:0;border:0':'color:#fff;padding-left:0;border:0'">{{myjigouname}}</span>
            <img src="../../assets/img/organ/xia1.png"
                 v-show="myjigouname!='请选择机构'&&!ismyjigou"
                 alt="">
            <img src="../../assets/img/organ/xia2.png"
                 v-show="myjigouname=='请选择机构'&&!ismyjigou"
                 alt="">
            <img src="../../assets/img/organ/shang1.png"
                 v-show="myjigouname!='请选择机构'&&ismyjigou"
                 alt="">
            <img src="../../assets/img/organ/shang2.png"
                 v-show="myjigouname=='请选择机构'&&ismyjigou"
                 alt="">
            <div class="t4r1m t4rm"
                 style="top:36px"
                 @click.stop
                 v-show="ismyjigou">
              <p v-for="(item,index) in myjigoulist"
                 @click="tomyjigou(item)"
                 :key="index">{{item.unitName}}</p>
            </div>
          </div>
          <div class="t6titlerb"
               @click="isXuefen=1"
               :style="isXuefen==1?'background: #0B8586;color:#fff':''">学分项目
            <div class="dian"
                 v-show="havejf"></div>
          </div>
          <div class="t6titlerb"
               @click="isXuefen=2"
               :style="isXuefen==2?'background: #0B8586;color:#fff':''">非学分项目
            <div class="dian"
                 v-show="havenojf"></div>
          </div>
        </div>
      </div>
      <div class="top6t2 EC_width"
           v-if="uid!=0&&myjigoulist.length>0">
        <span>{{myjigouname}}</span>
      </div>
      <div class="top6 EC_width"
           v-if="uid!=0&&myjigoulist.length>0">
        <div class="t6xm"
             v-show="myXiangmu.length!=0">
          <div class="t6xm1"
               v-show="!ist6xm">
            <div class="t6xmbox"
                 v-for="(item,index) in myXiangmu.slice(0,5)"
                 :style="myXiangmuId==item.id?'background: linear-gradient(119deg, #008F91, #F7AE00);':''"
                 @click="toXiangmu(item)"
                 :key="index">
              <span class="t6xmtitle"
                    :style="myXiangmuId==item.id?'color:#fff;font-weight: bold;':''">{{item.p_Name}}</span>
              <div class="t6xmtime"
                   v-show="item.id>0"
                   :style="myXiangmuId==item.id?'color:#fff':''">
                <span v-if="item.startDate!=null">{{item.startDate.substring(0,10)}}</span>
                <span> — </span>
                <span v-if="item.endDate!=null">{{item.endDate.substring(0,10)}}</span>
              </div>
              <img src="../../assets/img/icon/jifen.png"
                   v-show="item.isCredit"
                   alt="">
            </div>
          </div>
          <div class="t6xm2"
               v-show="ist6xm">
            <div class="t6xmbox"
                 v-for="(item,index) in myXiangmu"
                 :style="myXiangmuId==item.id?'background: linear-gradient(119deg, #008F91, #F7AE00);':''"
                 @click="toXiangmu(item)"
                 :key="index">
              <span class="t6xmtitle"
                    :style="myXiangmuId==item.id?'color:#fff':''">{{item.p_Name}}</span>
              <div class="t6xmtime"
                   v-show="item.id>0"
                   :style="myXiangmuId==item.id?'color:#fff':''">
                <span v-if="item.startDate!=null">{{item.startDate.substring(0,10)}}</span>
                <span> — </span>
                <span v-if="item.endDate!=null">{{item.endDate.substring(0,10)}}</span>
              </div>
              <img src="../../assets/img/icon/jifen.png"
                   v-show="item.isCredit"
                   alt="">
            </div>
          </div>
          <div class="t6xmshow"
               @click="ist6xm=!ist6xm">
            <span v-show="!ist6xm">更多</span>
            <span v-show="ist6xm">收起</span>
            <img src="../../assets/img/icon/gengduo.png"
                 v-show="!ist6xm"
                 alt="">
            <img src="../../assets/img/icon/shouqi.png"
                 v-show="ist6xm"
                 alt="">
          </div>
        </div>
        <div class="t6xian"></div>
        <!-- <div class="t6btn"
             v-if="mykecheng.length!=0"
             v-show="isXuefen==1">
          <div class="t6btnbox"
               @click="openxueji">
            学籍信息补充
          </div>
          <div class="t6btnbox"
               @click="openxuefen"
               style="background: #B70009;">
            学分查询
          </div>
          <div class="xuefenBox">
            <el-dialog :visible.sync="isxuefenBox"
                       width="440px">
              <div class="xftop">
                <img src="../../assets/img/icon/jifen.png"
                     alt="">
                <span>学分查询</span>
              </div>
              <div class="xfmid">
                {{creditContent}}
              </div>
            </el-dialog>
          </div>
          <div class="xuejiBox">
            <el-dialog :visible.sync="isxuejiBox"
                       width="456px">
              <div class="xftop">
                <span>学籍信息查看</span>
              </div>
              <div class="xfmid">
                <el-form label-width="85px">
                  <el-form-item label="姓名：">
                    <el-input v-model="form.name"
                              placeholder="请输入姓名"
                              clearable></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号：">
                    <el-input v-model="form.number"
                              placeholder="请输入身份证号"></el-input>
                  </el-form-item>
                  <el-form-item label="工作单位：">
                    <el-input v-model="form.unit"
                              placeholder="请输入工作单位"></el-input>
                  </el-form-item>
                  <el-form-item label="职称：">
                    <el-select v-model="form.position"
                               placeholder="请选择职称">
                      <el-option v-for="item in positionOptions"
                                 :key="item.id"
                                 :label="item.valueText"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="学历：">
                    <el-select v-model="form.edu"
                               placeholder="请选择学历">
                      <el-option v-for="item in eduOptions"
                                 :key="item.id"
                                 :label="item.valueText"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="科室：">
                    <el-select v-model="form.department"
                               placeholder="请选择科室">
                      <el-option v-for="item in departmentOptions"
                                 :key="item.id"
                                 :label="item.valueText"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="地区："
                                style="height:40px;position: relative;">
                    <el-cascader v-model="form.region"
                                 :placeholder="region?'':'请选择省市区县'"
                                 :options="arealist"
                                 @expand-change="expandChange"></el-cascader>
                    <span style="position: absolute;top:0px;left:15px;color: #606266;"
                          v-show="form.region==''">{{region}}</span>
                  </el-form-item>
                  <div class="xuejibtn">
                    <div class="xuejibtnbox"
                         @click="postxueji"
                         style="background: #0B8586;color:#fff">
                      提交
                    </div>
                    <div class="xuejibtnbox"
                         @click="isxuejiBox=false">
                      取消
                    </div>
                  </div>
                </el-form>
              </div>
            </el-dialog>
          </div>
        </div> -->
        <div class="t6kc">
          <div class="t3mid EC_width"
               v-show="mykecheng.length>0">
            <div class="t3mbox"
                 v-for="(item,index) in mykecheng.slice(0,isgengduo?mykecheng.length:8)"
                 :style="(index+1)%4==0?'margin-right:0':''"
                 @click="tokecheng(item.courseId)"
                 :key="index">
              <img :src="item.coverPicture"
                   alt="">
              <div class="t3mboxbot">
                <span class="t3title">{{item.title}}</span>
                <div class="t3biaoqian">
                  <span>学习进度</span>
                  <div class="jindu">
                    <div class="jindubox"
                         :style="'width:'+Math.ceil(item.learning*100)+'%'"></div>
                  </div>
                </div>
                <div class="t3more">
                  <div>
                    <span>已学 </span>
                    <span style="color:#0b8586">{{Math.ceil(item.learning*100)}}%</span>
                  </div>
                  <div v-show="myXiangmuId>0">
                    <img src="../../assets/img/icon/ren.png"
                         style="width:10px;height:11px;margin-right:10px"
                         alt="">
                    <span>{{item.numberPeople}}人</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="t3bot"
               v-show="mykecheng.length>8">
            <div class="t6gengduo"
                 @click="isgengduo=!isgengduo">
              <img src="../../assets/img/icon/xiangxia.png"
                   :style="isgengduo?'transform: rotate(180deg);':''"
                   alt="">
              <span v-show="!isgengduo">更多课程</span>
              <span v-show="isgengduo">收起</span>
            </div>
          </div>
          <div class="t3mid2"
               v-show="mykecheng.length==0">
            <span>没有找到符合条件的课程</span>
          </div>
        </div>
      </div>
    </div>
    <footer_index></footer_index>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import '../../assets/js/china';
import { areaList } from '@vant/area-data';
import header_index from '../../components/header2';
import footer_index from './footer_index';
import cardSwiper from '../../components/cardSwiper/index.vue';
export default {
  components: {
    header_index,
    footer_index,
    cardSwiper
  },
  data () {
    return {
      orgId: 0,
      isbqzhankai: false,
      xiangmuList: [],
      xiangmuIndex: 0,
      jigouList: [],
      kechengList: [],
      mapmax: 0,
      province: '请选择省份',
      provinceId: '',
      isprovince: false,
      provincelist: [],
      type: '请选择类别',
      typeId: 0,
      orgname: '',
      istype: false,
      typelist: [],
      organList: [],
      uid: 0,
      isXuefen: 0,
      ist6xm: false,
      myXiangmu: [],
      myXiangmuId: 0,
      mykecheng: [],
      isgengduo: false,
      isxuefenBox: false,
      creditContent: '',
      isxuejiBox: false,
      form: {
        name: '',
        number: '',
        unit: '',
        position: '',
        edu: '',
        department: '',
        region: ''
      },
      positionOptions: [],
      eduOptions: [],
      departmentOptions: [],
      arealist: [],
      oidInfo: '',
      region: '',
      myjigouname: '请选择机构',
      myjigouid: 0,
      ismyjigou: false,
      myjigoulist: [],
      swiperOption: {
        loop: true,
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled'
        },
        slidesPerView: 5, //设置slider容器能够同时显示的slides数量(carousel模式)。
        spaceBetween: -150, //在slide之间设置距离（单位px）。
        centeredSlides: true, //设置活动块居中
      },
      havejf: false,
      havenojf: false,
      swiperOption1: {
        loop: true, // 循环模式选项
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive',
        },
      },
      /** tianlianpei */
      // banner
      bannerlist: [],
      isloading: false
    };
  },
  watch: {
    xiangmuIndex: function () {
      this.getxmkcList()
    },
    isXuefen: function () {
      this.getMyXiangmu()
    },
    myXiangmuId: function () {
      this.getMyKecheng()
    },
    orgId: function () {
      this.GetXiangmuList()
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id)
    }
    this.GetJigouList()
    this.getprovincelist()
    this.GetOrgTypeList()
    this.getMyjigou()
    this.getMyKecheng()
    this.getorganList()
    this.GetRotationInfo()
  },
  mounted () {
    // this.getSwiper()
    this.OrganDistributed()
  },
  methods: {
    //获取轮播数据
    GetRotationInfo () {
      let _this = this;
      let arr = [6]; //分别代表杂志专区轮播，底部，右上，右下
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 1
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 6) {
                _this.bannerlist = res.data.data || null;
              }
            }
          });
      }
    },
    swiperChange (e) {
      this.orgId = e
    },
    toEnter () {
      window.open('/user/userOrgEnter', '_blank')
    },
    getprovincelist () {
      this.provincelist.push({
        value: '',
        label: '请选择省份'
      });
      for (let a in areaList.province_list) {
        this.provincelist.push({
          value: a,
          label: areaList.province_list[a]
        });
      }
    },
    GetOrgTypeList () {
      this.httphelper
        .get('/api/BasicsmesApi/GetCodeResultList', {
          type: 5
        })
        .then(res => {
          if (res.code == 200) {
            this.typelist = res.data
            this.typelist.unshift({
              id: '0',
              valueText: '请选择类别'
            });
          }
        });
    },
    toDetail (id) {
      this.$router.push({
        path: '/expertsDetail',
        query: {
          id: id
        }
      });
    },
    GetJigouList () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganProjectList', {
          orgId: 0
        })
        .then(res => {
          if (res.data.code == 200 && res.data.data.organList.length > 0) {
            this.jigouList = res.data.data.organList
            this.orgId = res.data.data.organList[3].oId
            this.GetXiangmuList()
          }
        });
    },
    GetXiangmuList () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganProjectList', {
          orgId: this.orgId
        })
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.projectList == null || res.data.data.projectList.length == 0) {
              this.xiangmuList = []
              this.xiangmuIndex = 0
              this.kechengList = []
            } else {
              this.xiangmuList = res.data.data.projectList
              if (res.data.data.projectList[0]) {
                this.xiangmuIndex = res.data.data.projectList[0].pId
                this.getxmkcList()
              }
            }
          }
        });
    },
    getxmkcList () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganCourseList', {
          oid: this.orgId,
          pgid: this.xiangmuIndex
        })
        .then(res => {
          if (res.data.code == 200) {
            this.kechengList = res.data.data.slice(0, 8)
          }
        });
    },
    OrganDistributed () {
      this.httphelper.get('/api/CGPEnterPriseApi/OrganDistributed').then(res => {
        if (res.code == 200) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].value > this.mapmax) this.mapmax = res.data[i].value
          }
          this.setChart(res.data)
        }
      });
    },
    setChart (data) {
      var myChart = echarts.init(this.$refs.box1);
      var geoCoordMap = {
        '北京': [116.46, 39.92],
        "天津": [117.4219, 39.4189],
        "河北": [114.4995, 38.1006],
        "山西": [112.3352, 37.9413],
        '内蒙古': [110.3467, 41.4899],
        "辽宁": [123.1238, 42.1216],
        "吉林": [125.8154, 44.2584],
        '黑龙江': [127.9688, 45.368],
        '上海': [121.4648, 31.2891],
        "江苏": [118.8062, 31.9208],
        "浙江": [119.5313, 29.8773],
        "安徽": [117.29, 32.0581],
        "福建": [119.4543, 25.9222],
        "江西": [116.0046, 28.6633],
        "山东": [117.1582, 36.8701],
        "河南": [113.4668, 34.6234],
        "湖北": [114.3896, 30.6628],
        "湖南": [113.0823, 28.2568],
        "广东": [113.12244, 23.009505],
        "广西": [108.479, 23.1152],
        "海南": [110.3893, 19.8516],
        "重庆": [108.384366, 30.439702],
        "四川": [103.9526, 30.7617],
        "贵州": [106.6992, 26.7682],
        "云南": [102.9199, 25.4663],
        "西藏": [91.1423, 29.6552],
        "陕西": [109.1162, 34.2004],
        "甘肃": [103.5901, 36.3043],
        "青海": [101.4038, 36.8207],
        "宁夏": [106.3586, 38.1775],
        "新疆": [87.6335, 43.7992],
        "香港": [114.173355, 22.320048],
      }
      var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      };
      var mapmax = this.mapmax
      let option = {
        trigger: 'item',
        visualMap: {
          show: true,
          min: 0,
          max: mapmax,
          left: 'left',
          top: 'bottom',
          //   text: ['高', '低'], // 文本，默认为数值文本
          calculable: true,
          seriesIndex: [1],
          inRange: {
            color: ['#04387b', '#467bc0'] // 蓝绿
          }
        },
        tooltip: {
          padding: 0,
          transitionDuration: 1,
          textStyle: {
            color: '#000',
            decoration: 'none',
          },
          borderColor: 'rgba(7,166,255,0.7)',
          trigger: 'item',
          formatter: function (params) {
            if (typeof (params.value)[2] == "undefined") {
              var toolTiphtml = ''
              for (var i = 0; i < data.length; i++) {
                if (params.name == data[i].name) {
                  toolTiphtml = '<div style="width:200px;height:100px;background:rgba(22,80,158,0.8);border:1px solid rgba(7,166,255,0.7)!important">'
                    + '<div style="width:80%;height:40px;line-height:40px;border-bottom:2px solid rgba(7,166,255,0.7);padding:0 20px;">' + '<i style="display:inline-block;width:8px;height:8px;background:#16d6ff;border-radius:40px;">' + '</i>'
                    + '<span style="margin-left:10px;color:#fff;font-size:16px;">' + data[i].name + '</span>' + '</div>'
                    + '<div style="padding:20px">'
                    + '<p style="color:#fff;font-size:12px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px">' + '</i>'
                    + '单位总数：' + '<span style="color:#11ee7d;margin:0 6px;">' + data[i].value + '</span>' + '个' + '</p>'
                    + '</div>' + '</div>';
                }
              }
              return toolTiphtml;
            } else {
              var toolTiphtml = ''
              for (var i = 0; i < data.length; i++) {
                if (params.name == data[i].name) {
                  toolTiphtml = '<div style="width:200px;height:100px;background:rgba(22,80,158,0.8);border:1px solid rgba(7,166,255,0.7)!important">'
                    + '<div style="width:80%;height:40px;line-height:40px;border-bottom:2px solid rgba(7,166,255,0.7);padding:0 20px;">' + '<i style="display:inline-block;width:8px;height:8px;background:#16d6ff;border-radius:40px;">' + '</i>'
                    + '<span style="margin-left:10px;color:#fff;font-size:16px;">' + data[i].name + '</span>' + '</div>'
                    + '<div style="padding:20px">'
                    + '<p style="color:#fff;font-size:12px;">' + '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px">' + '</i>'
                    + '单位总数：' + '<span style="color:#11ee7d;margin:0 6px;">' + data[i].value + '</span>' + '个' + '</p>'
                    + '</div>' + '</div>';
                }
              }
              return toolTiphtml;
            }
          }
        },
        geo: {
          show: true,
          map: "china",
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false,
            }
          },
          zoom: 1.2,
          roam: false,
          itemStyle: {
            normal: {
              areaColor: '#023677',
              borderColor: '#1180c7',
            },
            emphasis: {
              areaColor: '#4499d0',
            }
          }
        },
        series: [{
          name: '散点',
          type: 'scatter',
          coordinateSystem: 'geo',
          data: convertData(data),
          symbolSize: function (val) {
            return val[2] / mapmax * 15
          },
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            normal: {
              color: '#05C3F9'
            }
          }
        },
        {
          map: 'china',
          type: 'map',
          geoIndex: 0,
          aspectScale: 0.75, //长宽比
          showLegendSymbol: false, // 存在legend时显示
          label: {
            normal: {
              show: true
            },
            emphasis: {
              show: false,
              textStyle: {
                color: '#fff'
              }
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: '#031525',
              borderColor: '#3B5077',
            },
            emphasis: {
              areaColor: '#2B91B7'
            }
          },
          animation: false,
          data: data
        },
        {
          name: 'Top 5',
          type: 'effectScatter',
          coordinateSystem: 'geo',
          data: convertData(data.sort(function (a, b) {
            return b.value - a.value;
          }).slice(0, 5)),
          symbolSize: function (val) {
            return val[2] / mapmax * 15
          },
          showEffectOn: 'render',
          rippleEffect: {
            brushType: 'stroke'
          },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true
            }
          },
          itemStyle: {
            normal: {
              color: 'yellow',
              shadowBlur: 10,
              shadowColor: 'yellow'
            }
          },
          zlevel: 1
        },
        ]
      };
      myChart.setOption(option);
      myChart.on('click', (params) => {
        this.orgname = ''
        var reg = new RegExp(params.name);
        for (let a in areaList.province_list) {
          if (areaList.province_list[a].match(reg)) {
            this.province = areaList.province_list[a]
            this.provinceId = a
            this.getorganList()
          }
        }
      });
    },
    toprovince (item) {
      this.province = item.label
      this.provinceId = item.value
      this.getorganList()
      this.isprovince = false
    },
    totype (item) {
      this.type = item.valueText
      this.typeId = item.id
      this.getorganList()
      this.istype = false
    },
    searchclk () {
      if (this.orgname == '') {
        this.provinceId = ''
        this.province = '请选择省份'
        this.type = '请选择类别'
        this.typeId = 0
      }
      this.getorganList();
    },
    getorganList () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetGpOrganInfoList', {
          provinceCode: this.provinceId,
          org_type: parseInt(this.typeId),
          org_name: this.orgname
        })
        .then(res => {
          if (res.data.code == 200) {
            this.organList = res.data.data
          }
        });
    },
    toorgan (id) {
      window.open('/organDetail?id=' + id, '_blank')
    },
    getMyjigou () {
      this.httphelper.get('/api/CourseClassApi/GetMyUserOrgList', {
        UserId: Number(this.uid),
      })
        .then(res => {
          if (res.code == 200) {
            this.myjigoulist = res.data
            if (res.data[0]) {
              this.myjigouid = res.data[0].id
              this.myjigouname = res.data[0].unitName
            }
            this.gethavejf()
          }
        });
    },
    getMyXiangmu () {
      this.httphelper.get('/api/CourseClassApi/GetOrgProgectList', {
        UserId: Number(this.uid),
        OrgId: this.myjigouid,
        Type: this.isXuefen
      })
        .then(res => {
          if (res.code == 200) {
            this.myXiangmu = res.data
            if (res.data[0]) {
              this.myXiangmuId = res.data[0].id
              this.creditContent = res.data[0].creditContent
            } else {
              this.myXiangmuId = 0
              this.creditContent = ''
            }
            this.getMyKecheng()
          }
        });
    },
    getMyKecheng () {
      if (this.myXiangmuId == -1) {
        this.httphelper.get('/api/EnterpriseApi/GetIntCourseSchedList', {
          orgId: this.myjigouid,
          userId: Number(this.uid)
        })
          .then(res => {
            if (res.code == 200) {
              this.mykecheng = res.data
            }
          });
      } else if (this.myXiangmuId == -2) {
        this.httphelper.get('/api/CourseClassApi/GetUserLearprojPageList', {
          orgId: this.myjigouid,
          userId: Number(this.uid),
          limit: 99
        })
          .then(res => {
            if (res.code == 200) {
              this.mykecheng = []
              for (let i = 0; i < res.data.length; i++) {
                this.mykecheng.push({
                  coverPicture: res.data[i].pictureUrl,
                  learning: res.data[i].studyTime / res.data[i].length,
                  title: res.data[i].pname,
                  courseId: res.data[i].cid
                })
              }
            }
          });
      } else {
        this.httphelper.get('/api/CourseClassApi/GetProgectCourseList', {
          UserId: Number(this.uid),
          ProId: this.myXiangmuId,
        })
          .then(res => {
            if (res.code == 200) {
              this.mykecheng = res.data
            }
          });
      }
    },
    tokecheng (id) {
      if (this.myXiangmuId == -1) {
        let { href } = this.$router.resolve({
          path: '/course',
          query: {
            cid: id,
            orgid: this.myjigouid
          }
        });
        window.open(href, '_blank');
      } else if (this.myXiangmuId == -2) {
        if (this.$cookies.get('token_chinagp')) {
          window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + id + '&token=' + this.$cookies.get('token_chinagp'), "_blank")
        } else {
          window.open('https://www.jumingedu.com/qkyx/courseDetails?id=' + id, "_blank")
        }
      } else {
        if (this.$cookies.get('token_chinagp')) {
          window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id + '&token=' + this.$cookies.get('token_chinagp'), "_blank")
        } else {
          window.open(this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id, "_blank")
        }
      }
    },
    openxuefen () {
      this.isxuefenBox = true
    },
    openxueji () {
      for (let i = 1; i < 7; i++) {
        this.httphelper.get('/api/BasicsmesApi/GetCodeResultList', {
          type: i
        })
          .then(res => {
            if (res.code == 200) {
              if (i == 2) this.positionOptions = res.data
              else if (i == 1) this.eduOptions = res.data
              else if (i == 3) this.departmentOptions = res.data
            }
          });
      }
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        });
      }
      this.GetMyInfo()
      this.isxuejiBox = true
    },
    expandChange (val) {
      if (val.length == 1) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            this.arealist[i].children = [];
          }
        }
        for (let b in areaList.city_list) {
          if (b.substr(0, 2) == val[0].substr(0, 2)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                this.arealist[i].children.push({
                  value: b,
                  label: areaList.city_list[b],
                  children: []
                });
              }
            }
          }
        }
      } else if (val.length == 2) {
        for (let i = 0; i < this.arealist.length; i++) {
          if (this.arealist[i].value == val[0]) {
            for (let a = 0; a < this.arealist[i].children.length; a++) {
              if (this.arealist[i].children[a].value == val[1]) {
                this.arealist[i].children[a].children = [];
              }
            }
          }
        }
        for (let b in areaList.county_list) {
          if (b.substr(0, 4) == val[1].substr(0, 4)) {
            for (let i = 0; i < this.arealist.length; i++) {
              if (this.arealist[i].value == val[0]) {
                for (let a = 0; a < this.arealist[i].children.length; a++) {
                  this.arealist[i].children[a].children.push({
                    value: b,
                    label: areaList.county_list[b]
                  });
                }
              }
            }
          }
        }
      }
    },
    GetMyInfo () {
      this.httphelper.post('/api/CGpUserApi/GetUserMessage', {
        id: this.uid,
      })
        .then(res => {
          if (res.data.data) {
            this.form.name = res.data.data.userName
            this.form.number = res.data.data.iDcard
            this.form.unit = res.data.data.unit
            this.form.position = res.data.data.professionalId
            this.form.edu = res.data.data.educatId
            this.form.department = res.data.data.admoffId
            this.oidInfo = res.data.data
            for (let a in areaList.province_list) {
              if (a == res.data.data.province) {
                this.region = areaList.province_list[a]
              }
            }
            for (let a in areaList.city_list) {
              if (a == res.data.data.city) {
                this.region = this.region + ' / ' + areaList.city_list[a]
              }
            }
            for (let a in areaList.county_list) {
              if (a == res.data.data.district) {
                this.region = this.region + ' / ' + areaList.county_list[a]
              }
            }
          }
        });
    },
    postxueji () {
      this.httphelper.post('/api/CGpUserApi/UpdUserCredit', {
        userId: Number(this.uid),
        userName: this.form.name,
        unit: this.form.unit,
        iDcard: this.form.number,
        province: this.form.region[0] ? this.form.region[0] : this.oidInfo.province,
        city: this.form.region[1] ? this.form.region[1] : this.oidInfo.city,
        district: this.form.region[2] ? this.form.region[2] : this.oidInfo.district,
        professionalId: Number(this.form.position),
        educatId: Number(this.form.edu),
        admoffId: Number(this.form.department)
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('提交成功');
            this.isxuejiBox = false
          } else {
            this.$message.error('提交失败');
          }
        });
    },
    toXiangmu (item) {
      this.myXiangmuId = item.id
      this.creditContent = item.creditContent
    },
    tomyjigou (item) {
      this.myjigouname = item.unitName
      this.myjigouid = item.id
      this.isXuefen = 0
      this.gethavejf()
      this.ismyjigou = false
    },
    gethavejf () {
      this.havejf = false
      this.havenojf = false
      this.httphelper.get('/api/CourseClassApi/GetOrgProgectList', {
        UserId: Number(this.uid),
        OrgId: this.myjigouid,
        Type: 0
      })
        .then(res => {
          if (res.code == 200) {
            this.myXiangmu = res.data
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].isCredit) this.havejf = true
              else this.havenojf = true
            }
            if (res.data[0]) {
              this.myXiangmuId = res.data[0].id
              this.creditContent = res.data[0].creditContent
            } else {
              this.myXiangmuId = 0
              this.creditContent = ''
            }
            this.getMyKecheng()
          }
        });
    },
  }
};
</script>

<style scoped>
.content {
    min-height: 650px;
}
.top {
    height: 300px;
    width: 100%;
    min-width: 1240px;
    background-size: 100% 526px;
    background-repeat: no-repeat;
}
.bannerBgWrap {
    height: 300px;
    width: 100%;
}
.bannerWrap {
    min-height: 300px;
}
.bannerBgWrap img {
    /* height: 400px; */
    /* background: url(/image/qiye/qy_bg.png) center no-repeat; */
    /* background-size: 300px 1900px; */
    height: 300px;
    /* width: 100%; */
    width: 1920px;
    object-fit: cover;
}
.topbox {
    height: 300px;
    position: relative;
}
.topEnter {
    width: 284px;
    height: 200px;
    background: #0b8586;
    opacity: 0.95;
    border-radius: 10px 10px 0px 0px;
    position: absolute;
    right: 0;
    top: 223px;
    z-index: 80;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    box-sizing: border-box;
    cursor: pointer;
    left: 50%;
    margin-left: 337px;
}
.topEnter img {
    margin-top: 26px;
}
.topEnter span {
    margin-top: 16px;
}
.topEnter div {
    width: 43px;
    height: 1px;
    background: #ffffff;
    margin-top: 22px;
}
.top2 {
    height: 380px;
    padding-top: 70px;
    padding-bottom: 30px;
    box-sizing: border-box;
}
.t2b {
    position: relative;
    width: 100%;
    height: 100%;
}
.boxTitle {
    height: 60px;
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    border-bottom: 1px solid #eee;
}
.boxTitle span {
    border-left: 3px solid #0b8586;
    padding-left: 10px;
}
.t3top {
    display: flex;
    justify-content: space-between;
}
.t3tleft {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
}
.biaoqian {
    height: 35px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 18px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 33px;
    padding: 0 23px;
    margin-right: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    cursor: pointer;
}
.t3tright {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 75px;
}
.t3mid {
    display: flex;
    flex-wrap: wrap;
}
.t3mbox {
    height: 288px;
    width: 280px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-right: 40px;
    margin-bottom: 30px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    border-radius: 0px 0px 5px 5px;
    cursor: pointer;
}
.t3mbox img {
    height: 158px;
    width: 280px;
}
.t3mbox ::v-deep .el-image {
    height: 158px !important;
    width: 280px !important;
}
.t3mboxbot {
    padding: 15px 15px 20px;
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    /* height: 100%; */
}
.t3title {
    width: 100%;
    height: 38px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.t3more {
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #919ca3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t3biaoqian {
    display: flex;
    flex-wrap: wrap;
}
.t3biaoqian div {
    background: #ffffff;
    border: 1px solid #979fa6;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #979fa6;
    padding: 0px 3px;
    /* margin-left: 3px; */
    margin-right: 3px;
    margin-top: 1px;
    margin-bottom: 1px;
}
.t3biaoqian span {
    white-space: nowrap;
}
.t3mid2 {
    width: 100%;
    text-align: center;
    line-height: 100px;
}
.t3bot {
    display: flex;
    align-items: center;
    justify-content: center;
}
.t4tsearch {
    width: 334px;
    height: 46px;
    background: #ffffff;
    border: 1px solid #007380;
    box-sizing: border-box;
}
.t4tsearch input {
    height: 40px;
    width: 280px;
    box-sizing: border-box;
    margin-left: 10px;
    outline: none;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    border: none;
}
.t4tsearch img {
    width: 26px;
    height: 26px;
    margin-right: 12px;
    cursor: pointer;
}
.top4 {
    display: flex;
    justify-content: space-between;
    height: 673px;
    margin-bottom: 40px;
}
.t4left {
    width: 756px;
    height: 605px;
}
.t4right {
    width: 334px;
    padding-top: 30px;
    box-sizing: border-box;
}
.t4rt {
    width: 334px;
    height: 46px;
    background: #ffffff;
    border: 1px solid #007380;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 28px;
    padding-right: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    position: relative;
    cursor: pointer;
}
.t4rm {
    width: 334px;
    height: 210px;
    background: #ffffff;
    border: 1px solid #007380;
    box-sizing: border-box;
    position: absolute;
    top: 44px;
    left: -1px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    padding: 15px 20px 15px 28px;
    overflow-y: auto;
    z-index: 100;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.t4rm::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.t4rm::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.t4rm::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #f6f7fb;
    border-radius: 6px;
}
.t4rm p:hover {
    color: #0b8586;
}
.t4r2t {
    margin-top: 10px;
}
.t4r3 {
    width: 334px;
    height: 470px;
    background: #f6f7fb;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 25px;
    box-sizing: border-box;
    padding: 1px 28px;
    margin-top: 10px;
    overflow-y: scroll;
    z-index: 100;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.t4r3::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.t4r3::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.t4r3::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #f6f7fb;
    border-radius: 6px;
}
.t4r3 p {
    cursor: pointer;
    margin: 20px 0;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*不换行*/
    text-overflow: ellipsis; /*超出部分文字以...显示*/
}
.t4r3 p:hover {
    color: #0b8586;
}
.top6f {
    background: #f6f7fb;
    padding-top: 50px;
    padding-bottom: 50px;
}
.top6t {
    display: flex;
    justify-content: space-between;
}
.top6t .t6titler {
    display: flex;
}
.top6t .t6titlerb {
    height: 36px;
    background: #ffffff;
    border: 1px solid #d5d5d5;
    border-radius: 3px;
    margin-left: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 36px;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
}
.top6t .t6titlerb .dian {
    width: 6px;
    height: 6px;
    background: #ff0000;
    border-radius: 50%;
    position: absolute;
    top: 4px;
    left: 4px;
}
.top6t2 {
    margin-top: 15px;
    margin-bottom: 15px;
    height: 16px;
    padding-left: 10px;
    border-left: 2px solid #0b8586;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 16px;
}
.top6 .t6xm {
    position: relative;
}
.top6 .t6xmbox {
    width: 218px;
    height: 88px;
    background: #ffffff;
    border: 1px solid #0b8586;
    box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.08);
    border-radius: 3px;
    position: relative;
    margin-right: 10px;
    padding: 13px 18px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
}
.top6 .t6xmbox img {
    bottom: 13px;
    right: 15px;
    position: absolute;
}
.top6 .t6xmtitle {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.top6 .t6xmtime {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9f9f9f;
}
.top6 .t6xmshow {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.top6 .t6xmshow img {
    margin-left: 5px;
}
.top6 .t6xm1 {
    display: flex;
}
.top6 .t6xm2 .t6xmbox {
    margin-bottom: 10px;
}
.top6 .t6xm2 {
    display: flex;
    flex-wrap: wrap;
    min-height: 98px;
    max-height: 196px;
    overflow-y: scroll;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.top6 .t6xm2::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 6px;
    height: 4px;
}
.top6 .t6xm2::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #0b8586;
    border-radius: 6px;
}
.top6 .t6xm2::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: rgb(241, 241, 241);
    border-radius: 6px;
}
.top6 .t6xian {
    width: 1200px;
    height: 1px;
    margin: 15px 0;
    background-color: #eee;
}
.top6 .t6btn {
    margin-bottom: 30px;
    display: flex;
}
.top6 .t6btnbox {
    width: 201px;
    height: 32px;
    background: #0b8586;
    border-radius: 15px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    cursor: pointer;
}
.top6 .t6gengduo {
    width: 240px;
    height: 33px;
    background: #0b8586;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
.top6 .t6gengduo img {
    margin-right: 10px;
}
.top6 .jindu {
    width: 186px;
    height: 4px;
    background: #e5e5e5;
    border-radius: 2px;
    border: none;
    padding: 0 !important;
    margin: 0;
    margin-left: 8px;
}
.top6 .jindubox {
    width: 106px;
    height: 4px;
    background: #0b8586;
    border-radius: 2px;
    border: none;
    padding: 0 !important;
    margin: 0 !important;
}
.top6 .t3biaoqian {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.xuefenBox ::v-deep .el-dialog__body {
    padding: 10px 35px 40px;
}
.xftop {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}
.xftop img {
    margin-right: 10px;
    width: 22px;
    height: 22px;
}
.xfmid {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
}
.xuejiBox ::v-deep .el-dialog__body {
    padding: 10px 35px 40px;
}
.xuejiBox ::v-deep .el-input__inner {
    height: 35px;
    width: 297px;
}
.xuejiBox ::v-deep .el-form-item {
    margin-bottom: 10px;
}
.xuejibtn {
    display: flex;
    justify-content: center;
    margin-top: 18px;
}
.xuejibtnbox {
    width: 130px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #b6b6b6;
    border-radius: 16px;
    margin: 0 5px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.top2 .tbbtn {
    position: absolute;
    bottom: 120px;
}
.top2 .tbleft {
    left: -57px;
}
.top2 .tbright {
    right: -57px;
}
.top2 .tbbtn img {
    width: 37px;
    height: 37px;
}
.t2b1,
.t2b5 {
    width: 316px;
    height: 178px;
    box-shadow: 10px 17px 20px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    position: absolute;
    top: 50px;
    z-index: 20;
    background: #e3e3e3;
}
.t2b1 img,
.t2b5 img {
    width: 316px;
    height: 178px;
    border-radius: 5px;
}
.t2b1 .img2,
.t2b5 .img2 {
    width: 20px;
    height: 20px;
    padding: 79px 148px;
}
.t2b1 {
    left: 0;
}
.t2b5 {
    right: 0;
}
.t2b2,
.t2b4 {
    width: 401px;
    height: 226px;
    box-shadow: 10px 17px 20px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    position: absolute;
    top: 25px;
    z-index: 30;
    background: #e3e3e3;
}
.t2b2 img,
.t2b4 img {
    width: 401px;
    height: 226px;
    border-radius: 5px;
}
.t2b2 .img2,
.t2b4 .img2 {
    width: 20px;
    height: 20px;
    padding: 103px 190px;
}
.t2b2 {
    left: 152px;
    /* animation: you1 1s; */
}
.test {
    animation: you1 1s;
}
.t2b4 {
    right: 152px;
}
.t2b3 {
    width: 496px;
    height: 280px;
    box-shadow: 10px 17px 20px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    position: absolute;
    top: 0px;
    z-index: 40;
    left: 372px;
    background: #e3e3e3;
    position: relative;
}
.t2b3box {
    width: 130px;
    height: 35px;
    background: #007380;
    border-radius: 5px 0px 0px 0px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    padding: 0 15px 0 15px;
    box-sizing: border-box;
    cursor: pointer;
}

.t2b3 img {
    width: 496px;
    height: 280px;
    border-radius: 5px;
}
.t2b3 .img2 {
    width: 20px;
    height: 20px;
    padding: 130px 238px;
}
.t2b3box img {
    width: 20px;
    height: 20px;
}
@keyframes you1 {
    0% {
        width: 401px;
        height: 226px;
        top: 25px;
        z-index: 30;
        left: 152px;
    }
    1% {
        width: 496px;
        height: 280px;
        top: 0px;
        z-index: 40;
        left: 300px;
    }
    100% {
        width: 401px;
        height: 226px;
        top: 25px;
        z-index: 30;
        left: 152px;
    }
}
.t2b ::v-deep .swiper-slide {
    width: 316px;
    height: 178px;
    border-radius: 5px;
    background: #e3e3e3;
    margin-top: 50px;
}
.t2b ::v-deep .swiper-slide-active {
    width: 496px;
    height: 280px;
    border-radius: 5px;
    background: #e3e3e3;
    position: relative;
    z-index: 300;
    margin-top: 0;
}
.t2b ::v-deep .swiper-slide-prev {
    width: 401px;
    height: 226px;
    border-radius: 5px;
    background: #e3e3e3;
    margin-top: 25px;
    z-index: 280;
}
.t2b ::v-deep .swiper-slide-next + .swiper-slide {
    width: 316px;
    height: 178px;
    border-radius: 5px;
    background: #e3e3e3;
    margin-top: 50px;
}
.t2b ::v-deep .swiper-slide-next {
    width: 401px;
    height: 226px;
    border-radius: 5px;
    background: #e3e3e3;
    margin-top: 25px;
    z-index: 280;
}
</style>
